module.exports = __webpack_public_path__ + "media/npc_dota_hero_arc_warden.95089c25.webm";